// TODO: Review AI Code for feature: System Landscape & Interactions Visualization - Entire file is AI-generated
import { z } from 'zod';
import { SystemLogoDataSchema } from '../../shared/logo.schema';
/**
 * Landscape System Schema
 * A system with aggregated metrics for the landscape view
 */ export const LandscapeSystemSchema = z.object({
    _id: z.string(),
    name: z.string(),
    logo: SystemLogoDataSchema.optional(),
    category: z.string().optional(),
    owner: z.object({
        _id: z.string(),
        firstName: z.string(),
        lastName: z.string()
    }).optional(),
    metrics: z.object({
        totalUsers: z.number(),
        totalProcesses: z.number(),
        totalConnections: z.number(),
        upstreamCount: z.number(),
        downstreamCount: z.number(),
        mediaBreaks: z.number()
    })
});
/**
 * Landscape Edge Schema
 * A directed interaction between two systems
 */ export const LandscapeEdgeSchema = z.object({
    source: z.string(),
    target: z.string(),
    count: z.number(),
    hasMediaBreak: z.boolean()
});
/**
 * Landscape Summary Schema
 * Organization-wide KPIs
 */ export const LandscapeSummarySchema = z.object({
    totalSystems: z.number(),
    totalConnections: z.number(),
    averageConnectionsPerSystem: z.number(),
    isolatedSystems: z.number(),
    topHubs: z.array(z.object({
        _id: z.string(),
        name: z.string(),
        logo: SystemLogoDataSchema.optional(),
        connectionCount: z.number()
    })),
    totalMediaBreaks: z.number()
});
/**
 * System Landscape Response Schema
 * GET /api/v2/system/landscape
 */ export const SystemLandscapeResponseSchema = z.object({
    data: z.object({
        systems: z.array(LandscapeSystemSchema),
        edges: z.array(LandscapeEdgeSchema),
        summary: LandscapeSummarySchema
    })
});

//# sourceMappingURL=get-system-landscape.schema.js.map